import { Component, OnInit, ViewChild, TemplateRef, Inject, ViewEncapsulation } from '@angular/core';
import { EscritoriosService, ParcelaService, DominiosService, LoteHonorarioService, UsuarioService } from '../shared/services/acordo-ressarcimento/api/services';
import { Observable, of, throwError } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LoadingService } from '../shared/services/components/loading.service';
import { AppComponent } from '../app.component';
import { Paginacao, Parcela, ParcelaPaginado, ProcedenciaAcordo, SituacaoLote, LoteHonorario } from '../shared/services/acordo-ressarcimento/api/models';
import { PsModalLoadingComponent } from 'porto-seguro-guide';
import { Router } from '@angular/router';

@Component({
  selector: 'app-receber-honorario',
  templateUrl: './receber-honorario.component.html',
  styleUrls: ['./receber-honorario.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class ReceberHonorarioComponent implements OnInit {
  public parcelaPaginado: ParcelaPaginado;
  public procedenciasAcordo: ProcedenciaAcordo[];
  public formPesquisa: FormGroup;
  public formLote: FormGroup;
  public loadingLista = false;
  public listaEscritoriosFiltro: any[];
  public nomeEscritorioFiltro: any[];
  public selected = '';
  public page: Paginacao;
  public dadosParcela: Parcela[];
  public dadosParcelaFull: Parcela[];
  public valorHonorarioChecado: number = 0;
  public parcelasSelecionadas: number[];
  source = [];
  columnsTemplate = [];
  public lote: LoteHonorario;
  public fileToUpload: String[] = [];
  public flagGerarHonorario: boolean;
  public flagExcelParcelasHonorario: boolean;
  public codigoEscritorio: number;
  public nomeEscritorio: string;
  public isEscritorio: boolean;
  public flagAjusteManual: boolean = JSON.parse(sessionStorage.getItem('flagAjusteManual'));
  public parcelaAtualizar: Parcela;
  public numeroLote;
  public escritorio: any;

  @ViewChild('templateMarca') private templateMarca: TemplateRef<any>;
  @ViewChild('templateVencimento') private templateVencimento: TemplateRef<any>;
  @ViewChild('templateValor') private templateValor: TemplateRef<any>;
  @ViewChild('templateJuros') private templateJuros: TemplateRef<any>;
  @ViewChild('templateHonorario') private templateHonorario: TemplateRef<any>;
  @ViewChild('templateDataPagamento') private templateDataPagamento: TemplateRef<any>;
  @ViewChild('templateDataBaixa') private templateDataBaixa: TemplateRef<any>;
  @ViewChild('templateSelecao') private templateSelecao: TemplateRef<any>;
  @ViewChild('templateLote') private templateLote: TemplateRef<any>;
  @ViewChild('ModalConcluidoLote') modalConcluidoLote: PsModalLoadingComponent;

  ramoParametro: any;
  sinistroParametro: any;
  anoSinistroParametro: any;

  produto: number;

  constructor(
    private formBuilder: FormBuilder,
    public parcelaService: ParcelaService,
    public loteHonorarioService: LoteHonorarioService,
    public escritorioService: EscritoriosService,
    private loading: LoadingService,
    public dominiosService: DominiosService,
    public usuarioService: UsuarioService,
    private router: Router,
    @Inject(AppComponent) public appComponent: AppComponent) { }

  public ngOnInit() {
    this.columnsTemplate = [
      { prop: 'acordo.nomeEscritorio', label: 'Escritório' },
      { prop: 'acordo.processoRessarcimento.codigoRamoSinistro', label: 'Ramo' },
      { prop: 'acordo.processoRessarcimento.numeroSinistro', label: 'Sinistro' },
      { prop: 'acordo.processoRessarcimento.anoSinistro', label: 'Ano' },
      { prop: 'acordo.processoRessarcimento.sequenciaItemSinistro', label: 'Item' },
      { prop: 'numeroParcela', label: 'N° parcela' },
      { label: 'Data de vencimento', template: this.templateVencimento },
      { prop: 'tipoSituacaoParcelaAcordo.nomeTipoSituacaoParcelaAcordo', label: 'Status' },
      { label: 'Valor da parcela', template: this.templateValor },
      { label: 'Juros', template: this.templateJuros },
      { label: 'Honorário', template: this.templateHonorario },
      { label: 'Data do pagamento', template: this.templateDataPagamento },
      { label: 'Data da baixa', template: this.templateDataBaixa },
      { label: 'Marca', template: this.templateMarca },
      { label: 'Atualizar Lote', template: this.templateLote },
      { label: 'Selecionar', template: this.templateSelecao, headerCheckboxable: true }
    ];

    this.dadosParcela = undefined;
    this.dadosParcelaFull = [];
    this.parcelaPaginado = undefined;
    this.criarFormPesquisa();
    this.criarFormLote();

    this.carregarDadosPagina();
  }

  selecionarTodos() {

    this.pesquisarParcelasPagas(0, 10000);

  }

  desmarcarTodos() {

    this.dadosParcelaFull.forEach(item => {
      if (this.parcelasSelecionadas.find(function (p) { return p == item.codigoParcela })) {
      var index = this.parcelasSelecionadas.indexOf(item.codigoParcela);
      if (index > -1) {
        this.parcelasSelecionadas.splice(index, 1);
        this.dadosParcela.splice(this.dadosParcela.indexOf(item), 1);
        this.valorHonorarioChecado = this.valorHonorarioChecado - item.valorHonorarioPago;
      }
      }
    });

  }

  carregarDadosPagina() {

    this.usuarioService.recuperarDadosUsuario().subscribe(result => {

        this.produto = result.produto;
        if (this.produto == 531) {
          this.columnsTemplate = this.columnsTemplate.filter(function(column) {
            return column.label !='N° Lote';
          })
        }
        this.carregarProcedenciasAcordo( result.produto );

        this.formPesquisa.controls['ramoSinistro'].setValue( result.produto );

        this.flagGerarHonorario = result.flagGeraHonorario;
        this.flagExcelParcelasHonorario = result.flagExcelParcelasHonorario;

        if( result.codigoEscritorio ) {
            this.codigoEscritorio = result.codigoEscritorio;
        }

        if( result.nomeEscritorio ) {
            this.nomeEscritorio = result.nomeEscritorio;
        }

        this.isEscritorio = result.flagEscritorio;
        if( this.isEscritorio ) {
            this.formPesquisa.controls['escritorio'].setValue( result.nomeEscritorio );
            this.formPesquisa.controls['codigoEscritorio'].setValue( result.codigoEscritorio );
        }
    });
  }

  private criarFormPesquisa() {
    this.formPesquisa = this.formBuilder.group({
      ramoSinistro: null,
      anoSinistro: null,
      dataDe: null,
      dataAte: null,
      escritorio: this.nomeEscritorio != null ? this.nomeEscritorio : null,
      codigoEscritorio: this.codigoEscritorio != null ? this.codigoEscritorio : null,
      codigoProcedencia: null,
      codigoModalidade: null,
      valorInicio: null,
      valorFinal: null
    });
  }

  private criarFormLote() {
    this.formLote = this.formBuilder.group({
      anexo: null
    });
  }

  handleUpload(event) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.fileToUpload.push(reader.result + "");
    };
    console.log(this.formLote.value['anexo']);
  }

  public autoCompleteBuscaEscritorio() {
    return (keyword: any): Observable<any> => {
      this.nomeEscritorioFiltro = [];

      var parametros: EscritoriosService.ObterEscritoriosParams = {
        nomeEscritorio: this.formPesquisa.controls['escritorio'].value,
        codigoRamoSinistro: this.appComponent.codigoRamo
      };

      this.escritorioService.obterEscritorios(parametros).subscribe(
        data => {
          this.listaEscritoriosFiltro = data;
          for (let key in data) {
            this.nomeEscritorioFiltro.push(data[key].nomeEscritorio);
          }
        }
      );
      return of(this.nomeEscritorioFiltro);
    };
  }

  public log(event) {
    console.log(event);
  }

  public autoCompleteBuscaEscritorioSelected($event) {
    this.selected = $event;
    for (let key in this.listaEscritoriosFiltro) {
      if (this.listaEscritoriosFiltro[key].nomeEscritorio == this.selected) {
        this.formPesquisa.controls['codigoEscritorio'].setValue(this.listaEscritoriosFiltro[key].codigoEscritorio);
      }
    }
  }

  public pesquisarParcelasPagas(page, perPage: number=10) {

    this.loading.open();

    if( this.formPesquisa.value['codigoEscritorio'] == null ) {
        this.appComponent.createAlert("Escritório obrigatório!", 'error');
        this.formPesquisa.controls['escritorio'].setErrors({ 'incorrect': true });
        this.loading.close();
        return;
    }

    this.parcelaPaginado = undefined;

    if (page == undefined) {
      this.valorHonorarioChecado = 0;
      this.parcelasSelecionadas = [];
      this.dadosParcela = [];
    }

    if (this.tratarCondicao(this.escritorio) == null && this.isEscritorio === false) {
      this.formPesquisa.controls['codigoEscritorio'].setValue(null);
    }

    var parametros: ParcelaService.ObterParcelasReceberLoteHonorarioParams = {
      ramoSinistro: this.tratarCondicao(this.formPesquisa.value['ramoSinistro']),
      anoSinistro: this.tratarCondicao(this.formPesquisa.value['anoSinistro']),
      codigoEscritorio: this.tratarCondicao(this.formPesquisa.value['codigoEscritorio']),
      codigoTipoProcedencia: this.tratarCondicao(this.formPesquisa.value['codigoProcedencia']),
      codigoModalidade: this.tratarCondicao(this.formPesquisa.value['codigoModalidade']),
      periodoInicial: this.tratarCondicao(this.formPesquisa.value['dataDe']),
      periodoFinal: this.tratarCondicao(this.formPesquisa.value['dataAte']),
      page: page == undefined ? 0 : page,
      perPage: perPage,
    };

    this.parcelaService.obterParcelasLoteHonorario(parametros).subscribe(response => {
      this.loading.close();
      this.parcelaPaginado = response;
      this.page = this.parcelaPaginado.paginacao;
      this.loadingLista = false;
      this.source = this.parcelaPaginado.parcelas;
      console.log('ACDDADOS'+JSON.stringify(this.source[1].acordo));
      if (perPage >= 10000 ) { // selectALL
        this.dadosParcelaFull = [];
        this.parcelaPaginado.parcelas.forEach(item => {
          console.log('ACDDADOS'+JSON.stringify(item.acordo));
          if (!this.parcelasSelecionadas.find(function (p) { return p == item.codigoParcela })) {
            this.parcelasSelecionadas.push(item.codigoParcela);
            this.dadosParcela.push(item);
            this.dadosParcelaFull.push(item);
            this.valorHonorarioChecado = this.valorHonorarioChecado + item.valorHonorarioPago;
          }
        });
      }
    }, error => {
      this.loading.close();
      const theError: string = error.error.mensagens[2].mensagem;
      this.loadingLista = false;
      this.appComponent.createAlert("Erro ao efetivar consulta!", 'error');
      console.log('Erro ao criar a proposta!' + error);
    });
  }

  public gerarRelatorioParcela() {

    this.loading.open();

    this.parcelaService.obterRelatorioParcela(this.dadosParcela).subscribe(response => {
      if (response) {
        const blob = new Blob([response], { type: 'application/vnd.ms-excel' });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
        this.appComponent.createAlert('Relatório emitido com sucesso.', 'success');
      }
      this.loading.close();
    }, error => {
      this.loading.close();
      const theError: string = error.error.mensagens[2].mensagem;
      this.loadingLista = false;
      this.appComponent.createAlert('Não foi possível gerar o relatório.', 'error');
      console.log('Erro ao criar a proposta!' + error);
    });

  }

  public validarFormulario(): boolean {
    var isValido = true;

    if (this.parcelasSelecionadas.length == 0) {
      this.appComponent.createAlert('Sua lista de parcelas está vazia', 'alert');
      return;
    }

    if (this.formLote.value['anexo'] == null || this.formLote.value['anexo'] == 0) {
      isValido = false;
      this.formLote.controls['anexo'].setErrors({ 'incorrect': true });
    }
    return isValido;
  }

  public gerarLote(componenteModalGravando, componenteModalPadrao) {

    if (!this.validarFormulario()) {
      return;
    } else {
      componenteModalPadrao.close();
      componenteModalGravando.open("save");
      console.log('Gerando lote');

      this.lote = {};
      this.lote.pessoa = {}
      this.lote.parcelaLista = {};

      this.lote.pessoa.codigoEscritorio = this.formPesquisa.value['codigoEscritorio'];
      if( this.produto == 531 ) {
        this.lote.codigoOrigemSistema = 57;
      } else {
        this.lote.codigoOrigemSistema = 67;
      }

      this.lote.valorTotalLote = this.valorHonorarioChecado;
      this.lote.valorTotal = this.valorHonorarioChecado;
      this.lote.parcelaLista.parcelas = this.dadosParcela;

      this.lote.nomeArquivoNotafiscal = this.formLote.value['anexo'];
      this.lote.conteudoArquivoNotafiscal = "" + this.fileToUpload;

      console.log('this.dadosParcela:', JSON.stringify(this.dadosParcela));
      console.log('this.valorHonorarioChecado:', JSON.stringify(this.valorHonorarioChecado));
      
      this.loteHonorarioService.salvarLoteHonorario(this.lote).subscribe(response => {
        this.lote.numeroLote = response.codigoLote;
        componenteModalGravando.close();
        this.modalConcluidoLote.open(null);
      }, error => {
        console.log("status code--->" + error.status)
        componenteModalGravando.close();
        this.appComponent.createAlert('Não foi possível gerar o lote.', 'error');
      });
    }
  }

  public modalConcluidoLoteClick() {
    setTimeout(() => {
      this.router.navigate(['/detalhe-honorario/' + this.lote.numeroLote]);
    }, 500);
  }

  private carregarProcedenciasAcordo(produto: number): void {
    this.dominiosService.obterProcedenciasAcordoPorRamo( produto ).subscribe(result => {
      this.procedenciasAcordo = result;
    });
  }

  public paginar(evt) {
    this.pesquisarParcelasPagas(evt.offset);
  }

  public limparPesquisa() {
    this.ngOnInit();
  }

  public changeParcelaSelecionada(event, codigoParcela: number): void {
    var parcela = this.parcelaPaginado.parcelas.find(function (p) { return p.codigoParcela == codigoParcela });

    var target = event.target;
    if (target.checked) {
      this.parcelasSelecionadas.push(codigoParcela);
      this.dadosParcela.push(parcela);
      this.valorHonorarioChecado = this.valorHonorarioChecado + parcela.valorHonorarioPago;
    } else {
      var index = this.parcelasSelecionadas.indexOf(codigoParcela);
      if (index > -1) {
        this.parcelasSelecionadas.splice(index, 1);
        //this.dadosParcela.splice(this.dadosParcela.indexOf(parcela), 1);
        this.dadosParcela.splice(index, 1);
        this.valorHonorarioChecado = this.valorHonorarioChecado - parcela.valorHonorarioPago;
      }
    }
  }

  public isParcelaSelecionada(codigoParcela: number): boolean {
    return this.parcelasSelecionadas.indexOf(codigoParcela) != -1;
  }

  public tratarCondicao(valor: any) {
    if (valor !== undefined && valor !== null && valor === '') {
      return null;
    }
    return valor;
  }

  public atualizarLote(ModalAtualizaLote, ModalGravando) {
    if (this.numeroLote === undefined || this.numeroLote === null) {
        this.appComponent.createAlert("Número do Lote obrigatório!", 'error');
        return;
    }

    ModalAtualizaLote.close();
    ModalGravando.open();

    const param: Parcela = {
      codigoParcela: this.parcelaAtualizar.codigoParcela,
      numeroLoteHonorario: {
        numeroLote: this.numeroLote
      }
    };

    this.parcelaService.atualizarLoteParcela(param).subscribe(data => {
      ModalGravando.close();
      this.appComponent.createAlert('Lote atualizado com sucesso!.', 'success');
    }, message => {
      ModalGravando.close();
      if (message.includes('404')) {
        this.appComponent.createAlert('Lote informado não existe', 'error');
      } else {
        this.appComponent.createAlert('Ocorreu um erro ao atualizar o Lote da Parcela', 'error');
      }
    });

    this.numeroLote = undefined;
  }

}
